<template>
  <div
    v-if="visibleBanners.length && showPromoBanners"
    class="promo-banner"
    :class="{ active: bannerContent }"
  >
    <Transition name="fade">
      <div
        v-if="bannerContent"
        :key="bannerIndex"
        :style="`--backgroundColor: ${bannerContent.BackgroundColorEnd ? `linear-gradient(to right, ${bannerContent.BackgroundColor}, ${bannerContent.BackgroundColorEnd})` : bannerContent.BackgroundColor}; --color: ${bannerContent.Color};`"
      >
        <div
          class="promo-banner__item"
        >
          <StrapiBlocksText
            v-if="bannerContent?.Text?.length"
            :nodes="bannerContent.Text"
          />
          <div
            v-if="bannerContent?.PromoCode?.length"
            class="promo-banner__code"
            @click="copyPromoCode"
          >
            <span class="promo-banner__code__code">
              {{ bannerContent.PromoCode }}
            </span>
            <span class="promo-banner__code__text">
              {{ $t('Code copied') }}
            </span>
            <IconCopy class="icon icon--copy" />
          </div>
        </div>

        <button
          type="button"
          class="promo-banner__close"
          @click="closePromoBanner()"
        >
          <IconClose />
        </button>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import layoutQuery from '~layers/app/graphql/layout.gql'

const { public: config } = useRuntimeConfig()
const { data } = await useAsyncQuery(layoutQuery, { locale: config.strapiLocale })

const promoBanners = computed(() => {
  return data?.value?.promoBanner?.PromoBanners?.filter((banner) => {
    let x = true
    if (banner.DateFrom && banner.DateFrom > new Date().toISOString()) {
      x = false
    }
    if (banner.DateTo && banner.DateTo < new Date().toISOString()) {
      x = false
    }
    return x
  })?.map((banner) => {
    return {
      ...banner,
      Text: JSON.parse(JSON.stringify(banner.Text).replace('{dynamic-delivery-promise}', deliveryPromise.value.content || '')),
    }
  }) || []
})

const showPromoBanners = useSessionStorage('show_promo_banners', true, { initOnMounted: true })

const visibleBanners = computed(() => {
  return promoBanners.value
})

const interval = ref(10000)
const bannerContent = ref()
const bannerIndex = ref(0)
let i = 0

const setActiveBanner = () => {
  bannerContent.value = visibleBanners.value[i]
  bannerIndex.value = i++

  i = i > visibleBanners.value.length - 1 ? 0 : i
}

const { isActive } = useIntervalFn(() => {
  if (isActive.value) {
    setActiveBanner()
  }
}, interval)

function closePromoBanner() {
  showPromoBanners.value = !showPromoBanners.value
}

const day = data?.value?.dayOfWeek
const deliveryPromise = computed(() => {
  const dpKey = Object.keys(data?.value?.deliveryPromise || {}).find(key => key.includes(`_${day}`))

  if (!dpKey || !data?.value?.deliveryPromise[dpKey]) {
    return ''
  }

  const [name, key] = dpKey.split('_')

  return {
    name,
    key,
    content: data?.value?.deliveryPromise[dpKey],
  }
})

function copyPromoCode() {
  if (bannerContent.value?.PromoCode) {
    navigator.clipboard.writeText(bannerContent.value.PromoCode)
  }
  const codeText = document.querySelector('.promo-banner__code__text')
  const codeCode = document.querySelector('.promo-banner__code__code')
  const iconCopy = document.querySelector('.icon--copy')
  if (codeText && codeCode && iconCopy) {
    codeCode.style.display = 'none'
    iconCopy.style.display = 'none'
    codeText.style.display = 'inline'

    setTimeout(() => {
      codeCode.style.display = 'inline'
      iconCopy.style.display = 'inline'
      codeText.style.display = 'none'
    }, 2000)
  }
}

onMounted(() => {
  setActiveBanner()
})
</script>

<style>
@import url("~layers/app/components/App/PromoBanner.css");
</style>
